<template>
  <div>
    <v-data-table
      must-sort
      :headers="headers"
      :pagination.sync="pagination"
      :rows-per-page-items="pagination.rowsPerPageItems"
      :total-items="pagination.totalItems"
      :loading="loading"
      :items="items"
      class="elevation-1"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-center">{{ props.item.calories }}</td>
        <td class="text-xs-center">{{ props.item.fat }}</td>
        <td class="text-xs-center">{{ props.item.carbs }}</td>
        <td class="text-xs-center">{{ props.item.protein }}</td>
        <td class="text-xs-center">{{ props.item.iron }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    name: 'LTable',
    data() {
      return {
        loading: false,
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 50,
          sortBy: 'fat',
          totalItems: 0,
          rowsPerPageItems: [50, 100, 250, 500, 1000]
        },
        items: [],
        headers: [],
      };
    },
    watch: {
      pagination: {
         handler(context) {
          this.loading = true;
          this.queryItems(context);
          this.loading = false;
        },
        deep: true,
      },
    },
    computed: {

    },
    methods: {
      queryItems(context) {
        const {sortBy, descending, page, rowsPerPage} = context;
        console.log(context);
      },
    },
  };
</script>

<style scoped>

</style>
